import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useInstall } from '../lib/install';
import { Modal } from './ui';
import { GameIcon } from './GameIcon';
import { Icon } from './Icon';

/**
 * "Get the app": opens the store listing, installs the web app (Android / desktop Chrome), or shows iPhone
 * users how to add it to the home screen. Renders nothing where there's nothing to offer (inside the apps,
 * already installed, game portals). `onDismiss` adds a close button.
 */
export function GetApp({ onDismiss }: { onDismiss?: () => void }) {
  const { t } = useTranslation();
  const { way, install } = useInstall();
  const [iosHelp, setIosHelp] = useState(false);
  if (!way) return null;
  return (
    <>
      <div className="card tight row get-app">
        <GameIcon name="phone" size={34} className="get-app-icon" />
        <div className="grow">
          <strong>{t('getApp.title')}</strong>
          <div className="faint">{t('getApp.body')}</div>
        </div>
        <button className="btn primary small" onClick={() => (way === 'ios' ? setIosHelp(true) : void install())}>
          {way === 'store' ? t('getApp.download') : t('getApp.install')}
        </button>
        {onDismiss && (
          <button className="btn ghost small icon" onClick={onDismiss} aria-label={t('common.close')}>
            <Icon name="x" size={18} />
          </button>
        )}
      </div>
      {/* Portalled: on the landing page the card sits in an animated (transformed) block that would trap a fixed sheet. */}
      {iosHelp &&
        createPortal(
        <Modal title={t('getApp.iosTitle')} onClose={() => setIosHelp(false)}>
          <ol className="get-app-steps">
            <li>
              {t('getApp.iosStep1')}{' '}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
                <path d="M12 3v12M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" />
              </svg>
            </li>
            <li>{t('getApp.iosStep2')}</li>
            <li>{t('getApp.iosStep3')}</li>
          </ol>
          <button className="btn primary full" onClick={() => setIosHelp(false)}>{t('getApp.gotIt')}</button>
        </Modal>,
          document.body,
        )}
    </>
  );
}
